<template>
  <span class="flex items-center gap-1.5">
    {{ title }}
    <ArrowUpDown :size="15" :stroke-width="1.75" />
  </span>
</template>

<script>
import { ArrowUpDown } from "lucide-vue-next";
export default {
  props: {
    title: String,
    mode: String,
  },
  components: {
    ArrowUpDown,
  },
};
</script>
